"use client";

import { c as _c } from "react/compiler-runtime";
import type { CartItemOutputDto } from "@sticker-giant/sg-frontend-common";
import { CurrencyFormatter } from "@sticker-giant/sg-frontend-common";
import { IconTag } from "@tabler/icons-react";
import { useCart } from "@/queries/useCart";
interface Props {
  item: CartItemOutputDto;
}
export function DiscountCoupon(t0) {
  const $ = _c(15);
  const {
    item
  } = t0;
  const {
    data: cart
  } = useCart();
  if (!item.couponDiscountAmount) {
    return null;
  }
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <IconTag size={16} />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const t2 = cart?.couponCode;
  let t3;
  if ($[1] !== t2) {
    t3 = <div className="flex items-center space-x-2">{t1}<p className="font-medium uppercase">{t2}</p></div>;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const t4 = cart?.couponDiscountDescription;
  let t5;
  if ($[3] !== t4) {
    t5 = <p className="text-sm text-neutral-500">{t4}</p>;
    $[3] = t4;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== t3 || $[6] !== t5) {
    t6 = <div className="flex flex-col">{t3}{t5}</div>;
    $[5] = t3;
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== item.couponDiscountAmount) {
    t7 = CurrencyFormatter.formatUSD(item.couponDiscountAmount);
    $[8] = item.couponDiscountAmount;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  const t8 = `-${t7}`;
  let t9;
  if ($[10] !== t8) {
    t9 = <p className="text-base font-medium text-green-600">{t8}</p>;
    $[10] = t8;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] !== t6 || $[13] !== t9) {
    t10 = <div className="flex justify-between">{t6}{t9}</div>;
    $[12] = t6;
    $[13] = t9;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  return t10;
}